import { createSlice } from '@reduxjs/toolkit'

// Constant
import { ROLE } from '@/constants/role'

interface MemberStateType {
  memberData: {
    isFetched: boolean
    memberInfoId: string
    nickName: string
    headshotUrl: string
    role: number
    socketToken: string
    refCode: string
    email: string
    roles: number[] | null
    phone: string
    isProfileCompleted?: boolean // Shop 自建登入 v2：/v1/member/profile 回傳，false 時 App 層跳「領取特別禮」Dialog
    needsUpgrade?: boolean // Shop 自建登入 v2：/v1/member/profile 回傳，true 表示 v1 舊帳號需升級（登入頁據此引導進升級流程）
  }
}

const initialState: MemberStateType = {
  memberData: {
    isFetched: false,
    memberInfoId: '',
    nickName: '',
    headshotUrl: '',
    role: ROLE.GUEST,
    socketToken: '',
    refCode: '',
    email: '',
    roles: [],
    phone: '',
  },
}

export const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    setMemberData: (state, { payload }) => {
      state.memberData = { ...state.memberData, ...payload.memberData }
    },
    resetMemberData: (state) => {
      state.memberData = initialState.memberData
    },
    setMemberRole: (state, { payload }) => {
      state.memberData.role = payload.role
    },
  },
})

export const { setMemberData, resetMemberData, setMemberRole } = memberSlice.actions

export default memberSlice.reducer
